import React from "react";
import { Form, FORM_CLEAR, FORM_END_PROCESSING } from "../../lib";
import { eventEmitter, notification } from "../../services";
import { User } from "../../models";
import { Constraints, Fields } from "./types";

type Props = {};
export class ResetPasswordForm extends React.Component<Props> {
    private order = ["email"];

    private fields: Fields = {
        email: {
            type: "email",
            value: "",
        },
    };

    private constraints: Constraints = {
        email: {
            presence: { message: "emailRequired" },
            email: { message: "emailInvalid" },
        },
    };

    constructor(props: Props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    async onSubmit(value: Record<string, any>) {
        try {
            await User.save(value, "reset-password");
            eventEmitter.emit(FORM_END_PROCESSING);
            eventEmitter.emit(FORM_CLEAR);
            notification.set("resetPasswordForm.success", "s");
        } catch (e) {
            eventEmitter.emit(FORM_END_PROCESSING);
            notification.set("resetPasswordForm.failed", "f");
        }
    }

    render() {
        return (
            <Form
                id="resetPassword"
                order={this.order}
                fields={this.fields}
                constraints={this.constraints}
                focusOnFirst={true}
                onSubmit={this.onSubmit}
            />
        );
    }
}
